import React, { useEffect, useState } from "react";
import {
    useTable,
    useGlobalFilter,
    usePagination,
    useSortBy,
} from "react-table";
import { useLocation } from "react-router-dom";
import { decrypt } from "../../../../utils/encodingdecoding";
import { arjunMerchantId } from "../../../../utils";
import { getCellAlignProps } from "../../../../utils/helper";

const Paginated = ({ data, originalData, setFilteredData, columns, templateList, fetch, onSearch, qrCount, selectedTemplate, setSelectedTemplate, selectedBatch, setSelectedBatch, selectedStatus, setSelectedStatus, showTable = true, children, headerLeft }) => {
    const [selectPage, setSelectPage] = useState();
    const [selectedPageIndex, setSelectedPageIndex] = useState(1);
    const [pageArray, setPageArray] = useState();
    const [searchText, setSearchText] = useState("");
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        state,
        page,
        setPageSize,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                hiddenColumns: ["searchText"],
                pageSize: 50
            },
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );
    const location = useLocation()
    const { pageSize } = state;


    useEffect(() => {
        return () => {
            localStorage.setItem("QRPageIndex", JSON.stringify(1));
        }
    }, [])

    useEffect(() => {
        if (qrCount) {
            let tempqrCount = qrCount / 50;
            let temp = Math.ceil(tempqrCount);
            setSelectPage(temp);
        } else {
            setSelectPage(0);
        }
    }, [qrCount]);

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("QRPageIndex"));
        if (tempPageIndex !== 1) {
            // fetch();
        }
    }, []); // eslint-disable-line

    useEffect(() => {
        const temp = Array.from({ length: selectPage }, (_, index) => index + 1);
        setPageArray(temp);
    }, [selectPage]);

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("QRPageIndex"));
        tempPageIndex ? setSelectedPageIndex(tempPageIndex) : setSelectedPageIndex(1);
    }, []);

    const handlePageIndex = (event) => {
        if (event.target.value !== "") {
            const number = Number(event.target.value);
            setSelectedPageIndex(number);
            localStorage.setItem("QRPageIndex", JSON.stringify(number));
            fetch(number, 50, selectedTemplate, selectedBatch);
        }
    };

    const handleNext = () => {
        if (selectedPageIndex < pageArray?.length) {
            setSelectedPageIndex(selectedPageIndex + 1);
            localStorage.setItem("QRPageIndex", JSON.stringify(selectedPageIndex + 1));
            fetch(selectedPageIndex + 1, 50, selectedTemplate, selectedBatch);
        }
    };

    const handlePrevious = () => {
        if (selectedPageIndex > 1) {
            setSelectedPageIndex(selectedPageIndex - 1);
            localStorage.setItem("QRPageIndex", JSON.stringify(selectedPageIndex - 1));
            fetch(selectedPageIndex - 1, 50, selectedTemplate, selectedBatch);
        }
    };
    const handleBatchFilter = async (e) => {
        const value = e.target.value;
        setSelectedPageIndex(1);
        setSearchText("");
        setSelectedTemplate("");
        setFilteredData(originalData);
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        setSelectedBatch(value)
    };

    const handleTemplateFilter = (e) => {
        const value = e.target.value;
        setSelectedPageIndex(1);
        setSearchText("");
        setSelectedBatch("");
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        setSelectedTemplate(value);
    };

    const handleStatusFilter = (e) => {
        setSelectedPageIndex(1);
        setSearchText("");
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        setSelectedStatus(e.target.value);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (!value) {
            onSearch("");
        }
    };

    const handleSearchClick = () => {
        if (!searchText.trim()) {
            onSearch("");
            return;
        }
        setSelectedPageIndex(1);
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        onSearch(searchText);
    };


    return (
        <div className="customTable">
            <div className="customTable__header">
                <div className="customTable__left">
                    {headerLeft}
                </div>
                {location.pathname.includes("qrcode-list") && (
                    <div className="d-flex flex-column align-items-end gap-2" style={{ flex: 1, minWidth: 0 }}>
                        <div className="d-flex gap-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search QR Code"
                                value={searchText}
                                onChange={handleSearch}
                                onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
                                style={{ width: "250px" }}
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSearchClick}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                )}

            </div>
            {showTable ? (
            <div className="customTable__body">
                <div className="table-responsive">
                    {page?.length ? (
                        <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {page.map((row, rowIndex) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()} key={rowIndex}>
                                            {row.cells.map((cell) => {
                                                return <td {...getCellAlignProps(cell)}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    ) : (
                        <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={9} style={{ textAlign: "center", display: "table-cell", textTransform: "Capitalize" }}>
                                        No data found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
            ) : children}
        </div>
    );
};

export default Paginated;
